
(function () {
  function initRowAnimate() {
    var grid = document.querySelector('#product-grid');
    if (!grid) return;

    var items = Array.from(grid.querySelectorAll('.grid__item'));
    if (!items.length) return;

    var observer = new IntersectionObserver(function (entries) {
      // collect intersecting items and group by row (same rounded top offset)
      var rowMap = {};
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var rowKey = Math.round(entry.target.getBoundingClientRect().top / 5) * 5;
        if (!rowMap[rowKey]) rowMap[rowKey] = [];
        rowMap[rowKey].push(entry.target);
      });

      // fire each row with a small stagger between rows
      Object.keys(rowMap)
        .map(Number)
        .sort(function (a, b) { return a - b; })
        .forEach(function (key, rowIdx) {
          rowMap[key].forEach(function (item) {
            setTimeout(function () {
              item.classList.add('rb-visible');
            }, rowIdx * 90);
          });
        });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    items.forEach(function (item) { observer.observe(item); });

    // re-observe any new items added by infinite scroll / pagination
    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.classList.contains('grid__item')) {
            observer.observe(node);
          }
        });
      });
    });
    mo.observe(grid, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRowAnimate);
  } else {
    initRowAnimate();
  }
})();
